import React ,{useEffect,useState} from 'react';
import { ConfigProvider, Input, Select } from 'antd';
import style from './chart.module.scss';
import noDataImg from '@/modules/pain-points/img/noData.png';
import EventBus from '@/modules/pain-points/hooks/eventBus';

const noData = ({ index }) => {
  const [isDetailLoading, setIsDetailLoading] = useState(false);
  useEffect(() => {
    EventBus.addEventListener('isDetailLoading', handleIsDetailLoading);
    return (() => {
      EventBus.removeEventListener('isDetailLoading', handleIsDetailLoading);
    });
  }, []);
  const handleIsDetailLoading = (e) => {
    setIsDetailLoading(e.detail);
  };  

  return <>
    <div style={{height: '100%', width: '100%',display:'flex',alignItems:'center',justifyContent:'center',paddingBottom:'100px',position:'relative'}}>
      <img src={noDataImg} style={{ height: '8vw', width: '14.7vw' }} />
        {isDetailLoading && index !=2 && (
          <div className={style.detailLoadingOverlay}>
            <div className={style.spinner}></div>
            <div className={style.loadingText}>Loading...</div>
          </div>
        )}
    </div>
  </>
}



export default noData;